export const languageConfig = {
  // All available languages with their display names
  availableLanguages: {
    en: { code: 'en', name: 'EN', fullName: 'English' },
    hr: { code: 'hr', name: 'HR', fullName: 'Hrvatski' },
    es: { code: 'es', name: 'ES', fullName: 'Español' },
    de: { code: 'de', name: 'DE', fullName: 'Deutsch' }
  },

  // Currently enabled languages
  enabledLanguages: ['en', 'hr'],

  // Default/fallback language
  defaultLanguage: 'en',

  // Helper methods
  isLanguageEnabled: (langCode) => {
    return languageConfig.enabledLanguages.includes(langCode);
  },

  getEnabledLanguages: () => {
    return languageConfig.enabledLanguages.map(code =>
      languageConfig.availableLanguages[code]
    );
  },

  getLanguageDisplayName: (langCode) => {
    return languageConfig.availableLanguages[langCode]?.name || langCode.toUpperCase();
  }
};

export default languageConfig;
